import React, { useContext } from "react";
import MainNavbar from "./MainNavbar";
import Hero from "./Hero";
import patentedImg from "../assets/images/patented.jpg";
import patentedImage from "../assets/images/patentai.jpg"
import bgVideo from "../assets/videos/explainer_video.mp4";
import patentCoverImg from "../assets/images/patentcover.png";
import { PatentContext } from "../context/PatentContextProvider.js";
import patentPdf from "../assets/images/US7643821.pdf";
import QuestionsAnswers from "./QuestionAnswers.js";
import { faqsAlert } from "../constants/constants.js";
import { Link } from "react-router-dom";
// import FAQS from "./Faqs";
import { Footer } from "./Footer";
import MainContent from "./MainContent.js";
import { companyData, patentsData } from "../constants/constants.js";


export const PatentedTechnology = () => {
    const { handleLinkClick } = useContext(PatentContext);
    return (
        <>
            <MainNavbar />
            <Hero
                bgImage={patentedImage}
                imageText={{
                    title: "Patented Technology",
                    // description:
                    //     "We can think of Advertising as a required activity for every industry.  We can understand that in today’s world, Mobile Phone usage is fully adopted.  It is therefore extremely rare to locate a technology that is so all pervasive, so wide reaching and ubiquitous that it is found utilized in your local small business to even that of the Presidential office. However, what is little noticed is the fundamental patented technology that underlies and enabled  advertisers to run the now-ubiquitous “call-to-action” mobile ad campaigns.",
                    // subHeading: "-Respected Industry Expert in Mobile Advertising"
                }}

            />
            <div className="bg-white pt-10 flex-grow ">

                <div className="flex flex-col items-center text-center p-6 ">
                    <div className="py-5">
                        <p className="text-sm md:text-xl text-justify px-5">
                            We can think of Advertising as a required activity for every industry.  We can understand that in today’s world, Mobile Phone usage is fully adopted.  It is therefore extremely rare to locate a technology that is so all pervasive, so wide reaching and ubiquitous that it is found utilized in your local small business to even that of the Presidential office. However, what is little noticed is the fundamental patented technology that underlies and enabled  advertisers to run the now-ubiquitous “call-to-action” mobile ad campaigns.
                        </p>
                    </div>

                    <div className="relative w-12/12 sm:w-10/12 md:w-8/12 lg:w-7/12 py-5 ">

                        <i class="fa fa-quote-left text-9xl text-gray-300 absolute -top-5 left-0"></i>
                        <blockquote className="text-lg text-gray-800 relative font-semibold px-12 z-10">
                            Let’s create a text messaging platform that enables your company to be compliant with the TCPA laws. That makes it super easy for your company to create an ad campaign for the relevant items right to users' mobile phones.
                        </blockquote>
                    </div>
                    <div>
                        <p className="text-gray-700 font-medium">Kenneth OHanlon</p>
                        <p className="text-teal-500 italic">Patent inventor</p>
                    </div>
                </div>
                <div className="flex pb-2 justify-center">
                    <video
                        controls
                        muted
                        loop
                        playsInline
                        className="w-11/12 sm:w-10/12 md:w-8/12 lg:w-6/12 xl:w-5/12 rounded-lg shadow-lg"
                    >
                        <source src={bgVideo} type="video/mp4" />
                    </video>
                </div>

                <div className="flex flex-col items-center text-center p-6 ">
                    <div className="relative w-11/12 sm:w-10/12 md:w-8/12 lg:w-6/12 py-3 sm:py-5 ">
                        <p>
                            <strong>
                         <Link className="text-blue-600" onClick={() => handleLinkClick('/trade')} to='/trade'>AccessU2 Mobile Solutions, MOTOM ™</Link> ensure reliable, fast TCPA-compliant delivery of relevant, time-sensitive, AND PERSISTENT mobile marketing material, using the communications platform with highest open rates of all, your text app. But, back in 2010, MOTOM ™ technology had not attained the universal adoption it has today.”
                            </strong>
                        </p>
                    </div>
                </div>
                <div className="flex pb-2 mt-5 justify-center">
                    <a href={patentPdf} target="_blank" rel="noopener noreferrer">
                        <img
                            className=" rounded-lg cursor-pointer"
                            src={patentCoverImg}
                            alt="Patent Cover"
                        />
                    </a>

                </div>
                <div>
                    <p className="text-center text-lg">
                        <Link className="text-blue-600" onClick={() => handleLinkClick("/contact-us")}
                            to='/contact-us'>Contact Us</Link><span>&nbsp; for a White Paper if you would like to learn more.</span>
                    </p>
                </div>

                <div className="flex flex-col items-center text-center p-6 ">
                    <div className="relative  w-full sm:w-10/12  py-3 sm:py-5 md:py-6  sm:px-6">
                        <p className="text-justify text-lg">
                            OHanlonIP, LLC (OHIP) is the current holder of the 821 patent.
                        </p>
                        <p className="text-justify text-lg mt-5">
                            At the foundation of this company, we wanted to make sure that we had the rights to the patent that broadly covers the Mobile Advertising space. AT's U.S. Patent No. 7,643,821 (the '821 patent) is that patent that is foundational to the very infrastructure of the mobile advertising industry. Filed in 2005 and issued in 2010, the patent solved the technological shortcomings of the state of the art, effectively enabling advertisers to push rich digital content (e.g., pictures, audio, and video) to mobile devices in real-time. This had never been done before, and we believe that this patented technology enabled the mobile ad industry to become what it is today. According to several industry studies, $75 Billion of US Media Advertising spending will be allocated towards Mobile Ads. Of note, this surpasses TV ($70B) and is significantly more than print ($18B), radio ($14B) and out of home ($8B) advertising combined. Without a proper system, method and intellectual property to administrate the technology, we believe the Mobile Advertising market would only be a fraction of what it is today.
                        </p>
                        <div className="text-justify mt-[45px]">
                            <h2 className="text-2xl text-justify sm:text-3xl md:text-4xl text-[#01a4e4] leading-9 sm:leading-10 font-bold mt-2 flex items-center justify-center">
                                Coverage, Immediacy and Innovation
                            </h2>
                            <div>
                                <span className="text-justify text-lg">
                                    The '821 patent covers the process of sending multi-media-capable (MMS) content to requesting mobile phones (we call them "mobile-originated (MO) opt-in's"), where the requests are generated from mobile users perceiving (seeing or hearing) ads.
                                </span>
                            </div>

                            <div className="py-5">
                                <span className="text-justify text-lg">
                                    All modern SMS-based advertising platforms in the U.S. take advantage of the then-novel combination of wireless communications technologies disclosed/required by the patent:
                                </span>
                            </div>

                            <div>
                                <span className="text-justify text-lg">
                                    SMS "Interoperability" among wireless carriers; and SMS "fast-pull" technology used in all modern systems via SMSC gateways. The advertising market has also moved into SMS/MMS marketing using the patented technology in great numbers as the high conversion rates of text-based mobile advertising campaigns have proven to outstrip the success rates of other digital advertising platforms (such as web advertising).
                                </span>
                            </div>
                            <div className="py-3 sm:py-4 md:py-5  sm:px-2 md:px-6 text-center">
                                <span className="text-lg sm:text-2xl md:text-2xl lg:text-2xl">
                                    <strong>
                                        <i>We're Simply a Mobile Marketing company with a Strong Legal team ensuring your company is in compliance.</i>
                                    </strong>
                                </span>
                            </div>

                        </div>
                    </div>
                    <div className="relative sm:w-10/12  text-justify mt-10">
                        {/* <FAQS /> */}
                        <div>
                            <div className="flex flex-col m-auto w-[95%] ">
                                {/* Left Section */}
                                <div className=" flex flex-col items-center md:items-center text-center md:text-left">
                                    <h2 className="text-2xl sm:text-3xl md:text-4xl text-[#01a4e4] pb-4 sm:pb-5 md:pb-6 px-4 font-bold">
                                        Please Contact us for a Demonstration
                                    </h2>
                                    <p className="pb-4 sm:pb-5 md:pb-6 text-[#3b4455] text-lg sm:text-xl md:text-xl font-light">
                                        We currently provide technical support via support tickets to our
                                        customers. General and/or Legal Inquiries will normally be responded
                                        through our
                                        <Link className="text-blue-600" to='/contact-us'> Webform </Link>
                                        within 24-48 hours.
                                    </p>
                                    <p className="text-[#000] pb-4 w-full sm:pb-5 md:pb-6 text-lg sm:text-xl md:text-xl ">
                                        Here are answers to some of the most common questions we get about
                                        the Messaging Platform.
                                    </p>
                                    
                                </div>

                                {/* Right Section (FAQs) */}
                                <div >
                                    <QuestionsAnswers faqs={faqsAlert} />
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="relative  w-full sm:w-10/12  py-3 sm:py-5 md:py-6 px-4 sm:px-6 md:px-8 text-justify">
                        <ol className="list-decimal list-inside">
                            {patentsData.patents.map((item) => {
                                return (
                                    <>
                                        <li key={item} className="pb-2 text-xl text-[#3b4455]">{item}</li>
                                    </>
                                )
                            })}
                        </ol>
                    </div>
                </div>

            </div>
            <Footer />
        </>
    )
}